import React, { Component } from 'react'
import ConsultaPerfisAdminConfig from './ConsultaPerfisAdmin'
class ComponentName extends Component {
    render() {
        return (
            <div>
                admin
            </div>
        )
    }
}


const config = {
    subConfig: [
        ConsultaPerfisAdminConfig,      
    ],
    route: {
        path: '/admin',
        exact: true,
        component: ComponentName,
    },
}


export default config


// WEBPACK FOOTER //
// ./src/routes/admin/index.js